import React from 'react';
import {
    Button,
} from 'antd';
import {
    PlusOutlined
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

function CreateButton({ linkTo }) {
    const navigate = useNavigate();

    return (
        <Button
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => navigate(linkTo)}
        >เพิ่ม</Button>
    )
}

export default CreateButton